module.exports = __webpack_public_path__ + "img/364.2a2c49b1.png";